var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.714 12.0004C19.2406 12.0004 18.8569 12.3842 18.8569 12.8576V21.4289C18.8569 21.9023 18.4731 22.286 17.9997 22.286H2.57139C2.098 22.286 1.71425 21.9023 1.71425 21.4289V4.28624C1.71425 3.81284 2.098 3.42909 2.57139 3.42909H12.857C13.3304 3.42909 13.7141 3.04534 13.7141 2.57194C13.7141 2.09854 13.3304 1.71484 12.857 1.71484H2.57139C1.15125 1.71484 0 2.8661 0 4.28624V21.4289C0 22.849 1.15125 24.0002 2.57139 24.0002H17.9998C19.4199 24.0002 20.5712 22.849 20.5712 21.4289V12.8575C20.5712 12.3842 20.1874 12.0004 19.714 12.0004Z",
    fill: "#33AEE0",
    className: "icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7101 4.04055C23.1001 3.65055 23.1001 3.00055 22.7101 2.63055L20.3701 0.290547C20.0001 -0.0994531 19.3501 -0.0994531 18.9601 0.290547L17.1201 2.12055L20.8701 5.87055L22.7101 4.04055ZM5.00009 14.2505V18.0005H8.75009L19.8101 6.93055L16.0601 3.18055L5.00009 14.2505Z",
    fill: "#33AEE0",
    className: "icon"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1ad54a09.svg";
export { ForwardRef as ReactComponent };